// extracted by mini-css-extract-plugin
export var brand = "_3n-8";
export var compact = "_3n-5";
export var extraSmall = "_3n-6";
export var icon = "_3n-0";
export var large = "_3n-3";
export var light = "_3n-1";
export var medium = "_3n-4";
export var outline = "_3n-a";
export var primaryDark = "_3n-9";
export var primaryLight = "_3n-7";
export var primaryModern = "_3n-b";
export var success = "_3n-2";